<template>
    <div>
        <div>
            <span @click="steps = 1">项目基础信息</span>
            <span @click="steps = 2">项目概况</span>
            <span @click="steps = 3">项目实施过程</span>
            <span @click="steps = 4">项目成效与反思</span>
        </div>
        <div>
            <RaceDetail v-if="steps == 1"></RaceDetail>
            <RaceOverview v-if="steps == 2"></RaceOverview>
            <ProjectProcess v-if="steps == 3"></ProjectProcess>
            <ProjectEffect v-if="steps == 4"></ProjectEffect>
        </div>
    </div>
</template>

<script>
import RaceDetail from './addRace/raceDetail.vue';
import RaceOverview from './addRace/raceOverview.vue';
import ProjectProcess from './addRace/projectProcess.vue';
import ProjectEffect from './addRace/projectEffect.vue';
export default {
    components: {
        RaceDetail,
        RaceOverview,
        ProjectProcess,
        ProjectEffect,
    },
    data() {
        return {
            steps: 1
        }
    },
    methods: {
        checkType() {

        }
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/pages/race/addRace.vue